import type {
  CharDashaRequest,
  CharDashaResponse,
  CharDashaPeriod,
  Karaka,
  JaiminiPrediction,
} from "@ishvaram/api-client";
export type { CharDashaRequest, CharDashaResponse, CharDashaPeriod, Karaka, JaiminiPrediction };
import { apiRequest } from "./_fetch";

export async function calculateCharDasha(req: CharDashaRequest): Promise<CharDashaResponse> {
  return apiRequest<CharDashaResponse>("/char-dasha", {
    method: "POST",
    body: JSON.stringify(req),
  });
}
